import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackAnalyticsEvent } from "./analytics";

const AnalyticsTracker = () => {
  const location = useLocation();
  useEffect(() => {
    // Construct a friendly screen name based on the current path or pass location.pathname directly
    const screenName = location.pathname;
    trackAnalyticsEvent.screenView(screenName);
  }, [location]);
  return null;
};

export default AnalyticsTracker;
